'use client'

import { mutate } from 'swr'
import useImmutableSwr from 'swr/immutable'

import {
  CustomerDataControllerApiFactory,
  type CustomerDataPreferredLanguage,
} from '@redteclab/api/clients/bully'

import { useBullyApi } from '../../../base-api-communication'
import { useGlobalConfigContext } from '../../../global-config'

const SWR_KEY = 'userCustomerPreferredLanguageGet'

export const useApiSwrGetCustomerPreferredLanguage = ():
  | CustomerDataPreferredLanguage
  | undefined => {
  const config = useGlobalConfigContext()
  const client = useBullyApi(CustomerDataControllerApiFactory)
  const fetcher = async (): Promise<CustomerDataPreferredLanguage> => {
    const response = await client.customerV1TenantPreferredLanguageGet({
      tenant: config.tenantAndEnv,
    })

    return response.data
  }

  const { data } = useImmutableSwr(SWR_KEY, fetcher, {
    revalidateOnMount: false,
  })

  return data
}

/**
 * triggers refetching of any active swr for the query
 */
export const userApiSwrGetCustomerPreferredLanguage = async (): Promise<
  CustomerDataPreferredLanguage | undefined
> => {
  return mutate<CustomerDataPreferredLanguage>(SWR_KEY)
}
